import '../../style/index.less';
import './index.less';
import "../../style/nsky/reset/tabs/index.less";



/** WEBPACK FOOTER **
 ** ./components/tabs/style/index.js
 **/